<script module lang="ts">
	import { anyGetter, type GenericScaleOptions } from '../../utils/accessors.js';
	import type { Snippet } from 'svelte';

	export interface SnippetContext<Datum> {
		datum: Datum;
		index: number;
	}

	export interface RowProps<Datum> {
		data: Datum[];
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		yScale: GenericScaleOptions<Datum, any, number>;
		children: Snippet<[SnippetContext<Datum>]>;
	}
</script>

<script lang="ts" generics="Datum">
	let { data, yScale, children }: RowProps<Datum> = $props();

	let yGet = $derived(anyGetter(yScale));
</script>

{#each data as datum, idx (datum)}
	{@const y = yGet(datum)}
	{@const snippetContext = { datum, index: idx }}
	<g transform="translate(0, {y})">
		{#if children}
			{@render children(snippetContext)}
		{/if}
	</g>
{/each}
